import { useEffect, useState } from "preact/hooks";
import { THEMES, THEME_LABELS, loadTheme, saveTheme, type Theme } from "./theme";

/** Three buttons: follow the system, light, dark. The choice is an app setting. */
export function ThemeControl() {
  const [theme, setTheme] = useState<Theme>("system");
  useEffect(() => {
    loadTheme().then(setTheme, () => undefined);
  }, []);
  const pick = (t: Theme) => {
    setTheme(t);
    void saveTheme(t).catch(() => undefined);
  };
  return (
    <span class="segmented" role="group" aria-label="Appearance">
      {THEMES.map((t) => (
        <button type="button" key={t} class={t === theme ? "active" : ""} aria-pressed={t === theme} onClick={() => pick(t)}>{THEME_LABELS[t]}</button>
      ))}
    </span>
  );
}
